import { TRootState } from '../storeTypes';
export const getUiState = (state: TRootState) => state.ui;
